import { render, staticRenderFns } from "./CreateChildOrderButton.vue?vue&type=template&id=a0d5e9a6"
import script from "./CreateChildOrderButton.vue?vue&type=script&lang=js"
export * from "./CreateChildOrderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports